module.exports = __webpack_public_path__ + "static/media/copy-icon.2538f28e.svg";